import React from "react";

import styles from "./GeoCodingSuggestPanel.module.css";
import { ISuggestedLocation } from "./ControlPanel";

export const GeoCodingSuggestPanel = ({
  position,
  suggestedLocations,
  handleRowClick,
  activeRowId,
}: {
  position: { top: number; left: number; height: number };
  suggestedLocations: ISuggestedLocation[] | null;
  handleRowClick: (i: number) => void;
  activeRowId: number | null;
}) => {
  // console.log("GeoCodingSuggestPanel");

  return (
    <div
      className={styles.container}
      style={{
        left: position!.left,
        top: position!.top + position!.height,
        width: 300,
      }}
    >
      {suggestedLocations &&
        suggestedLocations.map((location, i) => {
          return (
            <div
              className={`${styles.row} ${
                activeRowId === i ? styles.active : ""
              }`}
              key={location.id}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                handleRowClick(i);
              }}
            >
              {location.name}
            </div>
          );
        })}
    </div>
  );
};

export default React.memo(GeoCodingSuggestPanel);
